import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { COLOR_TABLE_CONVERTER_TOKEN, ColorTableConverter } from './color-table.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        colorTableFeature: {
          module: () => import('./color-table.module').then((m) => m.ColorTableModule),
          cmsComponents: ['color_table']
        },
      }
    }),
    {
      provide: COLOR_TABLE_CONVERTER_TOKEN,
      useClass: ColorTableConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        color_table: COLOR_TABLE_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class ColorTableFeatureModule {}
